module.exports = ".webhook-url{word-break:break-word}"